import { Aggregate } from './aggregate';
import { FilterHandler } from '../shared/filter-handler';

import { Specie } from './specie';
import { Ship } from './ship';

export class HeatmapAggregate extends Aggregate {
  id: number;
  name: string;
  polygon: string;
  captures: number;

  constructor(values: Object = {}) {
    super();
    Object.assign(this, values);
  }

  apiMap(values: Object = {}) {
    const statisticals = new HeatmapAggregate(values);
    return statisticals;
  }
}

export class HeatmapAggregateFilter extends FilterHandler {
  specie: Specie[] = [];
  ship: Ship[] = [];
  start_date: string;
  end_date: string;

  constructor(values: Object = {}) {
    super();
    this.specie = [];
    this.ship = [];
    this.start_date = '';
    this.end_date = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/heatmap-aggregate.ts